function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { differenceBy, intersectionBy, isEmpty } from 'lodash';
import { Icon } from "../../UI";
import Confirm from "../../App/Confirm";
import { Translate, actions, I18NApi } from "../../I18N";


import { SettingsHeader } from "./SettingsHeader";

const SetAsDefaultButton = ({
  className,
  onClick



}) => /*#__PURE__*/
_jsx("button", { type: "button", onClick: onClick, className: `btn btn-xs template-remove ${className}` }, void 0, /*#__PURE__*/
_jsx(Icon, { prefix: "far", icon: "star" }), " \xA0", /*#__PURE__*/
_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Set as default")));




const TranslationAvailable = () => /*#__PURE__*/
_jsx("div", { className: "translation-available" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Available default translation"));


const DeleteButton = ({
  onClick,
  className



}) => /*#__PURE__*/
_jsx("button", { className: `btn btn-danger btn-xs ${className}`, onClick: onClick, type: "button" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "trash-alt" }), " \xA0", /*#__PURE__*/
_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Delete language")));



const ResetDefaultTranslationButton = ({
  onClick,
  className



}) => /*#__PURE__*/
_jsx("button", { type: "button", onClick: onClick, className: `btn btn-xs ${className}` }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "sync" }), " \xA0", /*#__PURE__*/
_jsx("span", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Reset default translation")));




const mapStateToProps = (state) => ({
  languages: state.settings.collection.get('languages')
});
const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{
  addLanguage: actions.addLanguage,
  deleteLanguage: actions.deleteLanguage,
  setDefaultLanguage: actions.setDefaultLanguage,
  resetDefaultTranslations: actions.resetDefaultTranslations
},
dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);


const LanguageList = ({
  languages,
  setDefaultLanguage,
  deleteLanguage,
  addLanguage,
  resetDefaultTranslations
}) => {
  const [addingLanguage, setAddingLanguage] = useState();
  const [deletingLanguage, setDeletingLanguage] = useState();
  const [resettingLanguage, setResettingLanguage] = useState();

  const [installedLanguages, setInstalledLanguages] = useState([]);
  const [availableLanguages, setAvailableLanguages] = useState([]);

  useEffect(() => {
    I18NApi.getLanguages().
    then((languagesList) => {
      const currentLanguages = (languages === null || languages === void 0 ? void 0 : languages.toJS()) || [];
      const defaultLanguage = currentLanguages.find((l) => l.default === true);
      const installed = intersectionBy(languagesList, currentLanguages, 'key');
      const defaultInstalled =
      installed.find((l) => l.key === (defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.key)) || installed[0];
      defaultInstalled.default = true;
      setInstalledLanguages(installed);
      setAvailableLanguages(differenceBy(languagesList, currentLanguages, 'key'));
    }).
    catch((_e) => {});
  }, [languages]);

  if (isEmpty(installedLanguages)) {
    return null;
  }

  return /*#__PURE__*/(
    _jsx("div", { className: "panel panel-default settings-content" }, void 0, /*#__PURE__*/
    _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Languages")), /*#__PURE__*/

    _jsx("div", { className: "installed-languages" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Active Languages")),

    installedLanguages.map((language) => /*#__PURE__*/
    _jsx("div", { className: "row" }, language.key, /*#__PURE__*/
    _jsx("div", { className: "col" }, void 0, `${language.label} (${language.key})`), /*#__PURE__*/
    _jsx("div", { className: "col" }, void 0, /*#__PURE__*/
    _jsx(ResetDefaultTranslationButton, {
      onClick: () => {
        setResettingLanguage(language);
      },
      className: !language.translationAvailable ? 'action-hidden' : '' })), /*#__PURE__*/


    _jsx("div", { className: "col" }, void 0, /*#__PURE__*/
    _jsx(SetAsDefaultButton, {
      className: language.default ? 'btn-success' : '',
      onClick: !language.default ? () => setDefaultLanguage(language.key) : () => {} })), /*#__PURE__*/


    _jsx("div", { className: "col" }, void 0, /*#__PURE__*/
    _jsx(DeleteButton, {
      onClick: () => setDeletingLanguage(language),
      className: language.default ? 'action-hidden' : '' }))))), /*#__PURE__*/





    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Available Languages")), /*#__PURE__*/

    _jsx("div", { className: "available-languages" }, void 0,
    availableLanguages.map((language) => /*#__PURE__*/
    _jsx("div", { className: "row" }, language.key, /*#__PURE__*/
    _jsx("div", { className: "col" }, void 0,
    `${language.label} (${language.key}) `,
    language.translationAvailable && /*#__PURE__*/_jsx(TranslationAvailable, {})), /*#__PURE__*/

    _jsx("div", { className: "col" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: () => {
        setAddingLanguage(language);
      },
      className: "btn btn-success btn-xs template-remove" }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "plus" }), " \xA0", /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add language"))))))),






    addingLanguage && /*#__PURE__*/
    _jsx(Confirm, {
      accept: () => {
        addLanguage(_objectSpread({}, addingLanguage));
        setAddingLanguage(undefined);
      },
      cancel: () => {
        setAddingLanguage(undefined);
      },
      title: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm add"), "\xA0", addingLanguage.label),


      message: "This action may take some time while we add the extra language to the entire collection.",
      extraConfirm: true,
      type: "success" }),


    deletingLanguage && /*#__PURE__*/
    _jsx(Confirm, {
      accept: () => {
        deleteLanguage(deletingLanguage.key);
        setDeletingLanguage(undefined);
      },
      cancel: () => {
        setDeletingLanguage(undefined);
      },
      title: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm delete"), "\xA0", deletingLanguage.label),


      message: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Are you sure you want to delete"), "\xA0", deletingLanguage.label, "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "language?"), "\xA0", /*#__PURE__*/
      _jsx(Translate, { translationKey: "delete language warning" }, void 0, "This action may take some time, can not be undone and will delete all the information in that language.")),





      extraConfirm: true }),


    resettingLanguage && /*#__PURE__*/
    _jsx(Confirm, {
      accept: () => {
        resetDefaultTranslations(resettingLanguage.key);
        setResettingLanguage(undefined);
      },
      cancel: () => {
        setResettingLanguage(undefined);
      },
      title: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm reset translation"), "\xA0", resettingLanguage.label),


      message: /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Are you sure you want to reset translation for"), "\xA0",
      resettingLanguage.label, "\xA0", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "language?")),


      extraConfirm: true,
      type: "success" })));




};

export default connector(LanguageList);